module.exports = __webpack_public_path__ + "static/img/5-out.b5f1f02.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Events/Cleaniness/Cleaniness-pics/5-out.jpg
// module id = 5iTp
// module chunks = 0